import React, { PureComponent } from 'react'
import * as css from 'styles'
import styled from 'react-emotion'
import propStyles from 'prop-styles'

import Loading from 'components/Loading/Loading'
import Waypoint from 'react-waypoint'


const ImgWrapper = styled('div')({
  width: '100%',
  // height: 'auto !important',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: css.color.xlightgray,
  transition: css.transition.norm,

},({height, heightS, width, ratio, inView})=>({
  paddingTop: `${ratio}%`,
  height: 0,
  // opacity: inView ? 1 : 0,
}))

const contained = {
  height: '100%',
  maxHeight: '100%',
  width: 'auto',
  display: 'inline-block',
}

const absolute = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
}

const ImgStyle = styled('img')({
  width: '100%',
  maxWidth: '100%',
  height: 'auto',
  display: 'block',
  ...absolute,
  opacity: 0,
  // transition: `opacity ${css.speed[2]}ms linear`,
}, propStyles({
  loaded: {
    opacity: 1,
  }
}))

const ImgOverlay = styled('div')({
  ...absolute,
  zIndex: 2,
  opacity: 1,
  userSelect: 'none',
  pointerEvents: 'none',
  // background: css.color.green,
  backgroundColor: css.color.xlightgray,
  transition: `opacity ${css.speed[1]}ms linear`,
}, propStyles({
  loaded: {
    opacity: 0,
  }
}))

class Img extends PureComponent {

  state = {
    status: 'Pending',
    inView: false,
  }

  loadSrc = () => {
    let downloadingImage = new Image()
    downloadingImage.onload = () =>  this.setState({status: 'Success'})
    downloadingImage.onerror = () => this.setState({status: 'Error'})
    downloadingImage.src = this.props.src;
    return downloadingImage
  }

  onEnter = () => {
    // this.setState({ inView: true })
    if (!this.state.loaded && !this.state.failed) {
      this.timer = setTimeout(()=>{
        this.loadSrc()
      }, this.props.timer || 350)
    }
  }

  onLeave = () => {
    // this.setState({ inView: false })
    this.timer && clearTimeout(this.timer)
  }

  tryAgain = () => {
    if (this.props.retry && this.state.failed) {
      this.setState({status: 'Pending'}) // here not in loadSrc due to onEnter trigger
      this.loadSrc()
    }
  }

  render2() {
    return (
      <ImgStyle
        src={this.props.src}
        width={this.props.width}
        height={this.props.height}
      />
    )
  }

  render() {
    const ratio = (this.props.height / this.props.width) * 100;

    return (
      <Waypoint 
        onEnter={this.onEnter} 
        onLeave={this.onLeave}
        topOffset="-200%"
        bottomOffset="-200%"
      >
      <ImgWrapper
          onClick={this.tryAgain}
          transparent={this.props.transparent}
          ratio={ratio}
          // inView={this.state.inView}
        >
          {/* <Loading
            medium
            status={this.state.status}
            errormessage="Image not found"
            autoheight
            nospinner={this.props.nospinner}
          > */}
            <ImgStyle
              src={this.props.src}
              width={this.props.width}
              height={this.props.height}
              loaded={this.state.status === 'Success'}
            />
            {/* <ImgOverlay loaded={this.state.status === 'Success'} /> */}
            {this.props.overlay && (
              <div className="img-hover" style={{...absolute, zIndex: 3}} />
            )}
          {/* </Loading> */}
      </ImgWrapper>
      </Waypoint>
    )
  }
}


export default Img



// WEBPACK FOOTER //
// ./src/components/Img/Img.js